import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import profile from '../../assets/small-logo-512x512.png' 
import _constantUtil from '../../utils/Constant' 

function AddTournament() {
  const navigate = useNavigate() 
  const [leagueProfile, setLeagueProfile] = useState(profile); 

  const handleImage = event => {
    const file = event.target.files[_constantUtil.ZERO];

    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        setLeagueProfile(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
   
  return (
    <div className=''>
      <ToastContainer autoClose={2000} position='top-center' />
      <div className='row justify-content-center mx-4'>
        <div className='d-flex align-items-center justify-content-between p-0'>
          <h4 className='header-title mb-0 text-muted mt-3'>
            <Link onClick={() => navigate(-1)} className='header-sub-title'>
             All Tournament
            </Link>
            <span className="blr-player-view">
              <MdKeyboardDoubleArrowRight className='jumbo-red-text mb-1 mx-2 '/>
            </span>
            Add Tournament
          </h4>
          <button
            type='button'
            className='btn text-white mt-3 d-flex'
            onClick={() => navigate(-1)}
          >
          <MdKeyboardArrowLeft className=' fs-4' />
            Back
          </button>
        </div>
        <div className='card mt-3'>
          <div className='card-body'>
            <form>
              <div className='row flex-column flex-md-row p-0 d-flex align-items-center justify-content-center mb-4'>
                <div className='col-12 col-md-3 col-lg-4 d-flex flex-column align-items-center justify-content-center order-1 order-md-0 mb-3 mb-md-0'>
                  <img
                    src={leagueProfile}
                    alt='Profile'
                    className='img-thumbnail img-fluid'
                    style={{
                      borderRadius: '50%',
                      cursor: 'pointer',
                      objectFit: 'contain',
                      minHeight: '170px',
                      height: '170px',
                      maxWidth: '170px',
                      width: '170px',
                    }}
                  />
                  <div className='button-wrapper mt-4'>
                    <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                    <input
                      type='file'
                      accept='image/*'
                      onChange={handleImage}
                      className='upload-box form-control'
                      name='upload'
                      id='upload'
                      placeholder='Upload File'
                    />
                  </div>
                </div>
              </div>
            
              <div className='row py-2'>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='leaguename' className='form-label'>
                   Tournament Name
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='leaguename'
                    name='league_name' 
                    placeholder='Enter Tournament Name'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='knownname' className='form-label'>
                    Known Name
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='knownname'
                    name='known_name' 
                    placeholder='Enter Known Name'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='code' className='form-label'>
                    Code
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='code'
                    name='code'
                    placeholder='Enter Code'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='order' className='form-label'>
                    Order
                  </label>
                  <input
                    type='number'
                    className='form-control'
                    id='order'
                    name='order' 
                    placeholder='Enter Order'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='country' className='form-label'>
                    Country
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='country'
                    name='country' 
                    placeholder='Enter Country'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='format' className='form-label'>
                    Format
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='format'
                    name='format' 
                    placeholder='Enter Format'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='type' className='form-label'>
                    Type
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='type'
                    name='type' 
                    placeholder='Enter Type'
                    autoComplete='off'
                  />
                </div>
                <div className='mb-2 col-12 col-md-6'>
                  <label htmlFor='leaguetype' className='form-label'>
                  Tournament Type
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='leaguetype'
                    name='league_type' 
                    placeholder='Enter Tournament Type'
                    autoComplete='off'
                  />
                </div>
              </div>
              <button type='button' className='btn text-white mt-3' style={{ float: 'right' }}>
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddTournament
